// @flow
import { CLEAR_CREATION_TEMPLATES, RECEIVE_CREATION_TEMPLATES } from '../../../ActionsConst';

import type {
  ReceiveCreationTemplatesAction,
  ClearCreationTemplatesAction,
} from '../actions/templates/TemplatesActions';

const initialState: Array<Number> = [];

const creationSettingsTemplates = (
  state: Array<Number> = initialState,
  action: ReceiveCreationTemplatesAction | ClearCreationTemplatesAction,
): Array<Number> => {
  switch (action.type) {
    case RECEIVE_CREATION_TEMPLATES:
      return state.concat(action.templates);
    case CLEAR_CREATION_TEMPLATES:
      return initialState;
    default:
      return state;
  }
};

export default creationSettingsTemplates;
